import React from 'react'
import PropTypes from 'prop-types'
import { Switch } from 'antd'

const ChecSwitch = ({
  checked,
  disabled = false,
  onChange,
  className,
  name,
}) => (
  <Switch
    name={name}
    className={className}
    checked={checked}
    disabled={disabled}
    onChange={onChange}
  />
)

ChecSwitch.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default ChecSwitch
